import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";
import { CostImportSummarySchema } from "./preview-cost-import";

/**
 * Checks the cost CSV (sent as the first file) again and sets each matched
 * product's cost. Safe to retry: rows already applied come back unchanged.
 */
export const applyCostImport = {
  name: "applyCostImport" as const,
  input: z.object({}),
  output: z.object({
    summary: CostImportSummarySchema,
    updatedCount: z.number().int().nonnegative(),
    failures: z.array(
      z.object({
        rowNumber: z.number().int().positive(),
        productId: productIdFormat.schema,
        message: z.string(),
      }),
    ),
  }),
};
